import React from 'react';
import { HBox } from '../../layout';
import { ChatPersonImage } from './ChatPersonImage';
import { intl } from '../../../lib';
import type { MessageReaction } from '../chatTypes';
import { withScaledEmoji } from './scaledEmoji';
import type { EmojiData } from 'emoji-picker-react/src/types/exposedTypes';

export type ReactionDetailsProps = {
  reaction: MessageReaction;
  showEmoji: boolean;
  emojiData: EmojiData;
};
export const ReactionDetails = ({
  reaction,
  showEmoji,
  emojiData
}: ReactionDetailsProps) => {
  return (
    <>
      {reaction.sender.map(sender => (
        <HBox className="reaction-user-details" key={sender.uid}>
          <ChatPersonImage
            avatar="user"
            firstname={sender.firstname}
            lastname={sender.lastname}
          />
          <div className="reaction-sender">
            {sender.isSender
              ? intl('common.you')
              : `${sender.firstname} ${sender.lastname}`}
          </div>
          {showEmoji && withScaledEmoji(reaction.key, emojiData)}
        </HBox>
      ))}
    </>
  );
};
